










import { Component, Vue } from 'vue-property-decorator';
import {mapGetters} from 'vuex';
import {SDynamicComponent} from '@/components/dto/SDynamicComponent';
import DynamicComponents from '@/components/DynamicComponents.vue';
import {ScomponentMode} from '@/components/dto/ScomponentMode';
import {ScomponentModeImpl} from '@/components/dto/ScomponentModeImpl';
@Component({
    components: {DynamicComponents},
    computed: {...mapGetters(['user'])}
})
export default class Profile extends Vue {
    private mode: ScomponentMode = ScomponentModeImpl.prototype.empty();
    private schema: SDynamicComponent[] = this.formSchema();
    private data: {name: string; value: any}[] = [];

    constructor(){
        super();
        this.$store.dispatch('getProfile')
            .then(res => {
                let formData = [
                    {
                        name: "Name",
                        value: res.user.name
                    },
                    {
                        name: "Email",
                        value: res.user.email
                    },
                    {
                        name: "Username",
                        value: res.user.username
                    }
                ];
                this.data = formData;
            }).catch(err => {

            console.log(err);
        });
    }

    handle_function_call(e: any) {
        //@ts-ignore
        this[e]();
    };


    formSchema() : SDynamicComponent[]{
        return [{
            "component": {
                "uid": "",
                "name": "Card",
                "url": "http://localhost:5000/card.umd.min.js"
            },
            "data": {

                "title": "Registration",
                "classes": "mb-2",
                "styles": "margin-top: 20px",
                "body": [{
                    "component": {
                        "uid": "",
                        "name": "ValueList",
                        "url": "http://localhost:5000/ValueList.umd.min.js"
                    },
                    "data": {
                        "valueList": []
                    },
                    "componentMode":{editable:false,delete:false,addHint:false, moveComponent:false}
                },
                    {
                        "component": {
                            "uid": "",
                            "name": "Button",
                            "url": "http://localhost:5000/button.umd.min.js"
                        },
                        "data": {
                            "text": "Edit",
                            "variant": "primary",
                            "type": "submit",
                            "size": "",
                            "fn_name": "editProfile"
                        },
                        "componentMode":{editable:false,delete:false,addHint:false, moveComponent:false}
                    }],
            },
            "componentMode":{editable:false,delete:false,addHint:false, moveComponent:false}
        }]
    };
}

